const filterNames = {
  all: 'All',
};

export default filterNames;
